import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { TextField, FontIcon, FlatButton } from 'material-ui';
import { saveUserBeingEdited, resetPassword } from '../../../stores/settings/settings-actions';
import R from 'ramda';

class PersonalDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editingField: '',
      oldValue: '',
      newValue: '',
      firstName: '',
      lastName: '',
      oldPw: '',
      newPw: '',
      confirmPw: '',
    };
  }

  render() {
    const { currentEmail, settings, userId, updateUser, updatePW, emailAlias } = this.props;
    const editUserMessage = settings.editUserMessage;
    const passResetMessage = settings.passResetMessage;
    const userObj = R.propOr([], 'usersArray', settings).filter(user => user._id === userId)[0];
    const { editingField, newValue, oldPw, newPw, confirmPw, firstName, lastName, oldValue } = this.state;

    const fields = [
      { text: 'Name', value: `${R.propOr('', 'first_name', userObj)} ${R.propOr('', 'last_name', userObj)}`, updateKey: 'name' },
      { text: 'Email', value: currentEmail, updateKey: 'email' },
      { text: 'Password', value: '***********', updateKey: 'Password' },
    ];

    const pwFields = [
      { text: 'Old Password', stateVal: 'oldPw', value: oldPw },
      { text: 'New Password', stateVal: 'newPw', value: newPw },
      { text: 'Confirm New Password', stateVal: 'confirmPw', value: confirmPw },
    ];

    const resetState = () => this.setState({
      editingField: '',
      oldValue: '',
      newValue: '',
      oldPw: '',
      newPw: '',
      confirmPw: '',
      firstName: '',
      lastName: '',
    });

    const cancelButton = <FlatButton label="Cancel" primary onTouchTap={() => resetState()} />;

    return (
      <div>
        <div style={{ fontSize: '24px', fontWeight: 400, marginTop: '4px', paddingBottom: '12px', borderBottom: '1px solid #e6e9ec' }}>
          Personal Details
        </div>
        <div style={{ margin: '0 30px' }}>
          {
            fields.map((field, i) => (
              <div key={i} style={{ marginTop: '10px', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', fontSize: '14px' }}>
                <div style={{ fontWeight: R.equals(editingField, field.text) && 600 }}>{field.text}</div>
                <div>
                  {R.equals(editingField, field.updateKey) ?
                    <div>
                      {
                        editingField === 'Password' ?
                          <div style={{ display: 'flex', flexDirection: 'column' }}>
                            {
                              pwFields.map((pwField, j) => (
                                <div key={j} style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                                  <div style={{ marginRight: '10px' }}>{pwField.text}</div>
                                  <TextField type="password" id={pwField.text} value={pwField.value} onChange={({ target: { value } }) => this.setState({ [pwField.stateVal]: value })}/>
                                </div>
                              ))
                            }
                            {!R.isEmpty(newPw) && newPw.length < 6 && <div style={{ color: 'red', textAlign: 'center' }}>Password should have at least 6 characters!</div>}
                            {!R.isEmpty(confirmPw) && !R.isEmpty(newPw) && !R.equals(newPw, confirmPw) && <div style={{ color: 'red', textAlign: 'center' }}>New passwords do not match!</div>}
                            {R.propEq('error', true, passResetMessage) && <div style={{ color: 'red', textAlign: 'center' }}>{passResetMessage.errorMessage}</div>}
                            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' }}>
                              <FlatButton
                                label="Save"
                                secondary
                                disabled={R.isEmpty(oldPw) || R.isEmpty(newPw) || !R.equals(newPw, confirmPw) || newPw.length < 6}
                                onTouchTap={() => {
                                  updatePW(oldPw, newPw);
                                  if (R.propEq('error', false, passResetMessage)) {
                                    resetState();
                                  }
                                }}
                              />
                              {cancelButton}
                            </div>
                          </div> :
                          <div style={{ textAlign: 'right', display: 'flex', alignItems: 'center' }}>
                            {field.updateKey === 'name' ?
                              <div>
                                <TextField
                                  id="firstName"
                                  value={firstName}
                                  style={{ fontSize: '14px', width: '35%' }}
                                  onChange={({ target: { value } }) => this.setState({ firstName: value })}
                                />
                                <TextField
                                  id="lastName"
                                  value={lastName}
                                  style={{ fontSize: '14px', marginLeft: '10px', width: '35%' }}
                                  onChange={({ target: { value } }) => this.setState({ lastName: value })}
                                />
                              </div> :
                              <TextField
                                id={field.text}
                                value={newValue}
                                style={{ fontSize: '14px' }}
                                onChange={({ target: { value } }) => this.setState({ newValue: value })}
                              />
                            }
                            <FlatButton
                              label="Save"
                              secondary
                              disabled={editingField === 'name' ? (R.isEmpty(firstName) || R.isEmpty(lastName)) : R.isEmpty(newValue)}
                              onTouchTap={() => {
                                if (field.updateKey === 'name') {
                                  updateUser(R.merge(userObj, { first_name: firstName, last_name: lastName }));
                                  resetState();
                                } else {
                                  updateUser(R.merge(userObj, { [editingField]: newValue }));
                                  if (!R.propEq('emailExists', true, editUserMessage)) {
                                    resetState();
                                  }
                                }
                              }}
                            />
                            {cancelButton}
                            {R.propEq('emailExists', true, editUserMessage) && <div style={{ color: 'red' }}>{editUserMessage.message}</div>}
                          </div>
                      }
                    </div> :
                    <div style={{ display: 'inline-block' }}>
                      {field.value}
                      <FontIcon
                        className="tc-icon-mode_edit"
                        style={{ fontSize: '12px', color: 'rgb(0, 165, 187)', cursor: 'pointer', marginLeft: '10px' }}
                        onTouchTap={() => {
                          this.setState({
                            editingField: field.updateKey,
                            oldValue: field.value,
                            newValue: field.value,
                            firstName: R.propOr('', 'first_name', userObj),
                            lastName: R.propOr('', 'last_name', userObj),
                          });
                        }}
                      />
                    </div>
                  }
                </div>
              </div>
            ))
          }
          <div className="flex-tc-sb" style={{ marginTop: '10px', display: emailAlias ? 'flex' : 'none' }}>
            Email Alias
            <div
              className="hint--top"
              aria-label="Please contact support@tourconnect.com to edit"
            >
              {emailAlias}
              <FontIcon
                className="tc-icon-mode_edit"
                style={{ fontSize: '12px', marginLeft: '10px' }}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

PersonalDetails.propTypes = {
  currentEmail: PropTypes.string,
  updateUser: PropTypes.func,
  settings: PropTypes.object,
  userId: PropTypes.string,
  updatePW: PropTypes.func,
};

const mapDispatchToProps = dispatch => ({
  updateUser: userObject => dispatch(saveUserBeingEdited(userObject)),
  updatePW: (oldPassword, newPassword) => dispatch(resetPassword(oldPassword, newPassword)),
});

const mapStateToProps = ({ user, settings }) => ({
  currentEmail: settings.get('currentUserEmail'),
  userId: user.get('id'),
  settings: settings.toJS(),
  emailAlias: user.get('emailAlias'),
});

export default connect(mapStateToProps, mapDispatchToProps)(PersonalDetails);



// WEBPACK FOOTER //
// ./src/app/components/settings/mySettings/personalDetails.jsx